// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.checkout {
  background-color: #fff;
}

.panel {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.form-control {
  border: 1px solid #e2e2e2;
}

#form-checkout .has-error input {
  border-color: #F00;
}

.form-control.error {
  border: 1px solid #e53935;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
/*  alterações novas  */
.panel-body-altera {
  text-align: right;
}

.panel-body-altera .btn-confirmar {
  margin-bottom: 5px;
}

.panel-body-altera .cartoes-cadastrados {
  padding-bottom: 80px;
  padding-top: 10px;
}

.panel-body-altera .cartoes-cadastrados .cartao {
  padding: 10px;
  border: 2px solid #00caff;
  border-radius: 5px;
  background-color: #fff;
  text-align: left;
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: hsl(0, 0%, 30%);
  font-size: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.5s ease-out;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #8b8b8b;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #4379ff;
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: bolder;
  padding-left: 30px;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span > span {
  font-size: 19px;
  line-height: 1;
}

.panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  height: 26px;
  width: 66px;
}

.panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {
  width: 7px;
  height: 19px;
  display: inline-block;
  background-image: url(/assets/icones/menu-edit.svg);
  background-repeat: no-repeat;
  padding: 10px;
  background-position: center;
}

.panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,
.cartoes-cadastrados .cartao .validade-cartao strong {
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 15px;
}

.remover-dom {
  visibility: hidden;
  opacity: 0;
  display: none;
}

.flex {
  display: flex;
}

.space-between {
  justify-content: space-between;
  align-items: center;
}

h5 {
  color: #4d4d4d;
  font-size: 14px;
  line-height: inherit;
}

.info-venda .venda:last-child {
  margin-bottom: 20px;
}

.venda .valores {
  margin-bottom: 5px;
}

.venda .data-entrada {
  font-size: 12px;
  text-align: right;
}

.venda .data-entrada .valor-data {
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
}

.venda .valor-entrada {
  display: block;
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
  text-align: right;
}

/* #cartoes-cadastrados, #form-checkout {
    transition: opacity 0.5s ease;
} */
@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
.menu-remove {
  background-color: #FFF;
  width: 100px;
  height: 35px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 7px;
  text-align: center;
  border-radius: 0.25rem;
  position: relative;
  top: 12px;
  left: -78px;
}

.menu-remove:hover {
  background-color: #EFEFEF;
}

@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
@font-face {
  font-family: "pague-la";
  src: url("/assets/fonts/pague-la.eot");
  src: url("/assets/fonts/pague-la.eot?#iefix") format("embedded-opentype"), url("/assets/fonts/pague-la.woff2") format("woff2"), url("/assets/fonts/pague-la.woff") format("woff"), url("/assets/fonts/pague-la.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
}
.checkout.cls-container {
  background-color: #FFFFFF;
}

.checkout .cls-content {
  padding-top: 5vh;
}

.checkout .rodape {
  margin-top: 30px;
}

.checkout .rodape p {
  margin-right: auto;
  margin-left: auto;
}

.checkout .panel-content {
  display: flex;
}

.checkout p,
.checkout h4,
.checkout h5 {
  display: table;
}

.mb-clean {
  margin-bottom: 0;
}

.checkout .panel-body1 {
  width: 35%;
  background-color: #fff;
  padding: 20px 40px 25px;
  border-bottom-left-radius: 10px;
}

.checkout .panel-body1 .total {
  font-size: 18px;
  font-family: pague-la, "Open Sans", sans-serif;
}

.checkout .panel-body1 p {
  color: #999999;
  margin-bottom: 8px;
}

.checkout .panel-body1 h4 {
  color: #4379ff;
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 25px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .texto-destaque {
  color: #4379ff;
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .panel-body1 h5 {
  margin-top: 15px;
}

.checkout .panel-body2 {
  width: 65%;
  background-color: #fcfcfc;
  padding: 20px 40px 100px;
}

@media (min-width: 768px) {
  .checkout .cartao-credito {
    width: 100%;
  }
}
.checkout .form-control {
  font-size: 15px;
  font-weight: bolder;
}

input:-moz-placeholder,
input::-webkit-input-placeholder,
input:-ms-input-placeholder {
  color: red;
}

.checkout .panel {
  border-radius: 10px;
}

.checkout .panel-heading {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 80px;
  border-bottom: none;
}

.pagamento-seguro {
  text-align: right;
  position: absolute;
  right: 40px;
  top: 20px;
  color: #ffffff;
}

.pagamento-seguro p {
  display: inline-block;
}

.pagamento-seguro p strong {
  display: block;
}

.checkout .panel-heading:after {
  border-bottom: none;
}

.checkout .logo-paguela-cinza {
  margin-bottom: 30px;
}

.checkout .logo-paguela-cinza svg {
  height: 30px;
}

.checkout .panel-heading h3 {
  color: #fff;
  letter-spacing: 1px;
  text-align: left;
  font-size: 25px;
  padding-top: 15px;
  padding-left: 40px;
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: 100;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: default;
}

z .checkout label,
.registro .pad-all {
  color: #999999;
}

.checkout input,
.registro select {
  border-radius: 4px;
  border-color: #d9d9d9;
}

.checkout input:focus {
  border-color: #00CAFF;
}

.checkout .panel-heading {
  background: rgb(0, 204, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 204, 255)), color-stop(70%, rgb(161, 80, 253)), color-stop(100%, rgb(177, 54, 253)));
  background: linear-gradient(15deg, rgb(0, 204, 255) 0%, rgb(161, 80, 253) 70%, rgb(177, 54, 253) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ccff", endColorstr="#b136fd", GradientType=1);
}

.mt-20 {
  margin-top: 20px;
}

.btn-registrar,
.btn-primary {
  position: absolute;
  bottom: 40px;
  right: 40px;
  font-family: "Pague.la", "Open Sans", sans-serif;
  color: #fff;
  font-size: 1.8rem;
  padding: 7.5px 27px;
  border-radius: 5px;
  letter-spacing: 0.8px;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
  border: none;
  float: right;
}

.btn-registrar:active,
.btn-primary:active,
.btn-registrar:hover,
.btn-primary:hover,
.btn-registrar:focus .btn-primary:focus {
  color: #fff;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
}

#reinicia-venda {
  float: none;
}

.cadeado {
  max-width: 35px;
  display: inline-block;
  position: relative;
  top: 2px;
}

.cadeado svg {
  height: 30px;
}

#cartao-error {
  margin-bottom: 0 !important;
}

.checkout .form-group {
  margin-bottom: 15px;
}

.checkout .form-group .control-label {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

img.logo-cliente {
  max-width: 165px;
  max-height: 117px;
  margin: 10px auto;
}

.bandeira-cartao {
  width: 50px;
  height: 27px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin: 7px 0 0 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  right: 8px;
  top: 3px;
}

.checkout .has-feedback label ~ .form-control-feedback {
  top: 27px;
  right: 10px;
}

.master,
.visa,
.elo,
.diners,
.aura,
.jcb,
.hipercard,
.american-express {
  opacity: 1;
}

.default {
  opacity: 0;
}

.master {
  background-image: url("/assets/icones/mastercard.svg");
}

.hipercard {
  background-image: url("/assets/icones/hipercard.svg");
}

.visa {
  background-image: url("/assets/icones/visa.svg");
}

.american-express {
  background-image: url("/assets/icones/american-express.svg");
}

.diners {
  background-image: url("/assets/icones/diners.svg");
}

.discover {
  background-image: url("/assets/icones/discover.svg");
}

.elo {
  background-image: url("/assets/icones/elo.svg");
}

.jcb {
  background-image: url("/assets/icones/jbc.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .jcb {
    background-image: url("/assets/icones/jbc@2x.png");
  }
}
.aura {
  background-image: url("/assets/icones/aura.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .aura {
    background-image: url("/assets/icones/aura@2x.png");
  }
}
.btn.loading {
  color: transparent;
  height: 35px;
  width: 35px;
  padding: 0;
  border-radius: 50%;
  animation: loadBotao 0.25s ease, spin 0.75s linear infinite 0.25s;
}

.btn.loading:before {
  content: "";
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-color: #fcfcfc;
  position: relative;
  display: block;
  margin: 1px;
}

@keyframes loadBotao {
  from {
    height: initial;
    width: initial;
  }
  to {
    height: 35px;
    width: 35px;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#nometitular-error {
  margin-bottom: 40px;
}

#nometitular-error,
#cartao-error {
  color: #eb2521;
}

@media (max-width: 767px) {
  .checkout .panel-heading h3 {
    padding-left: 20px;
  }
  .checkout .cls-content {
    padding: 0;
  }
  .checkout .cls-content .cls-content-lg {
    width: 100%;
    box-shadow: none;
  }
  .checkout .panel-content {
    display: block;
  }
  .logo-cliente {
    display: block !important;
  }
  .info-loja * {
    display: block !important;
  }
  .panel-body2,
  .panel-body1 {
    width: 100% !important;
    text-align: center;
    padding: 20px !important;
  }
  .pagamento-seguro {
    right: 20px;
  }
  .info-pagamento {
    display: flex;
    justify-content: space-between;
  }
  #nometitular {
    margin-bottom: 100px;
  }
  .checkout .panel-heading {
    border-radius: 0;
  }
  /* .checkout .panel-heading h3 {
    position: relative;
    text-align: center;
    padding: 15px 0 0;
  }
  .pagamento-seguro {
    position: relative;
    text-align: center;
    top: 0;
    right: 0;
  }
  .pagamento-seguro p {
    text-align: right;
  } */
  .checkout .panel-body1 p.totais {
    position: absolute;
    float: left;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .checkout .form-group [for=validadeano].control-label {
    display: none;
  }
}
#resultado-sucesso h3 {
  display: block;
  color: #00caff;
  font-family: pague-la, "open sans", sans-serif;
  margin-top: 8px;
}

#resultado-reprovado h3 {
  display: block;
  color: #e95753;
  margin-top: 8px;
  font-family: pague-la, "open sans", sans-serif;
}

/*altura SVGS de validação*/
#resultado-sucesso svg,
#resultado-reprovado svg {
  height: 75px;
}

/*animação círculos svgs*/
#resultado-sucesso svg circle,
#resultado-reprovado svg circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2.5s ease forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
/* animação somente de sucesso */
#resultado-sucesso svg polyline {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3.5s ease forwards;
  animation-delay: 0.25s;
}

#resultado-reprovado svg .linha-1 {
  transform: translate(20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.3s;
}

#resultado-reprovado svg .linha-2 {
  transform: translate(-20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.4s;
}

@keyframes entrando {
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
/* animação reprovado */
#resultado-reprovado svg {
  animation: shake-reprovado 0.35s ease forwards;
  animation-delay: 0.6s;
}

@keyframes shake-reprovado {
  10%, 90% {
    transform: translate3d(0, -1px, 0);
  }
  20%, 80% {
    transform: translate3d(0, 2px, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(0, -4px, 0);
  }
  40%, 60% {
    transform: translate3d(0, 4px, 0);
  }
}
#resultado-sucesso .bandeira-cartao {
  position: absolute;
  top: -5px;
  right: 0px;
}

#resultado-sucesso .info-cartao {
  position: relative;
  padding-right: 75px;
}

#resultado-sucesso .fechar {
  margin-top: 40px;
}

#resultado-sucesso .info-transacao-aprovada {
  margin-top: 20px;
}

#resultado-sucesso .info-transacao-aprovada hr {
  margin: 10px 0 !important;
}

#resultado-sucesso .dados-aprovados {
  display: flex;
  justify-content: space-between;
}

.margin-auto {
  margin: 0 auto;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

/* página 404 */
.pagina-404 #container {
  background: rgb(0, 247, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 247, 255)), color-stop(75%, rgb(170, 0, 255)), color-stop(100%, rgb(170, 0, 255)));
  background: linear-gradient(45deg, rgb(0, 247, 255) 0%, rgb(170, 0, 255) 75%, rgb(170, 0, 255) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00f7ff", endColorstr="#aa00ff", GradientType=1);
}

.pagina-404 .btn-confirmar {
  position: initial;
}

.pagina-404 .text-main {
  font-family: pague-la, "open sans", sans-serif;
  font-size: 2rem;
}

h1.error-code {
  font-family: pague-la, "open sans", sans-serif;
  color: #fff;
}

.checkout .btn-confirmar {
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 1.7rem;
  padding: 10px 25px;
  border-radius: 5px;
  letter-spacing: 0.6px;
  background: rgb(0, 204, 255);
  background: -webkit-gradient(left top, right bottom, color-stop(0%, rgb(0, 204, 255)), color-stop(70%, rgb(161, 80, 253)), color-stop(100%, rgb(177, 54, 253)));
  background: linear-gradient(115deg, rgb(0, 204, 255) 0%, rgb(161, 80, 253) 70%, rgb(177, 54, 253) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ccff", endColorstr="#b136fd", GradientType=1);
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkout2/components/not-found/not-found.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,sBCsBM;ADtBR;;AAGA;EACE,sBCkBM;EDjBN,wCAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACI,yBAAA;EACA,gEAAA;EACA,+BAAA;EACA,2BAAA;EACA,mBAAA;AAAJ;;AAGE;EACE;IAEE,kCAAA;EADJ;EAGE;IAEE,iCAAA;EAFJ;EAIE;IAGE,kCAAA;EAJJ;EAME;IAEE,iCAAA;EALJ;AACF;AAQE,uBAAA;AAEA;EACE,iBAAA;AAPJ;;AAUE;EACE,kBAAA;AAPJ;;AAUE;EACI,oBAAA;EACA,iBAAA;AAPN;;AAUE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;AAPJ;;AAUE;EACE,yBAAA;EACA,0CAAA;EACA,cAAA;EACA,8DAAA;AAPJ;;AAUE;EACE,sBAAA;EACA,gCAAA;AAPJ;;AAUE;EACE,yBAAA;EACA,0CAAA;EAEA,cAAA;EACA,8CAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;AARJ;;AAWE;EACE,sBAAA;EACA,gCAAA;AARJ;;AAWE;EACE,eAAA;EACA,cAAA;AARJ;;AAWE;EACE,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AARJ;;AAWE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,mDAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;AARJ;;AAWE;;EAEE,8CAAA;EACA,eAAA;AARJ;;AAWE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AARJ;;AAWE;EACE,aAAA;AARJ;;AAWE;EACE,8BAAA;EACA,mBAAA;AARJ;;AAWE;EACE,cAAA;EACA,eAAA;EACA,oBAAA;AARJ;;AAWE;EACI,mBAAA;AARN;;AAWE;EACI,kBAAA;AARN;;AAWE;EACI,eAAA;EACA,iBAAA;AARN;;AAWE;EACI,8CAAA;EACA,mBAAA;EACA,eAAA;AARN;;AAWE;EACE,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AARJ;;AAWE;;GAAA;AAIA;EACE;IACE,YAAA;EATJ;AACF;AAYE;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAVJ;;AAaE;EACE,yBAAA;AAVJ;;AAaE;EACE;IACE,YAAA;EAVJ;AACF;AAaE;EACE,uBAAA;EACA,sCAAA;EACA,uOAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,yBAAA;AAZJ;;AAeE;EACE,gBAAA;AAZJ;;AAeE;EACE,gBAAA;AAZJ;;AAeE;EACE,kBAAA;EACA,iBAAA;AAZJ;;AAeE;EACE,aAAA;AAZJ;;AAeE;;;EAGE,cAAA;AAZJ;;AAeE;EACE,gBAAA;AAZJ;;AAeE;EACE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;AAZJ;;AAeE;EACE,eAAA;EACA,8CAAA;AAZJ;;AAeE;EACE,cAAA;EACA,kBAAA;AAZJ;;AAeE;EACE,cAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAZJ;;AAeE;EACE,cAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAZJ;;AAeE;EACE,gBAAA;AAZJ;;AAeE;EACE,UAAA;EACA,yBAAA;EACA,wBAAA;AAZJ;;AAeE;EACE;IACE,WAAA;EAZJ;AACF;AAeE;EACE,eAAA;EACA,mBAAA;AAbJ;;AAgBE;;;EAGE,UAAA;AAbJ;;AAgBE;EACE,mBAAA;AAbJ;;AAgBE;EACE,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AAbJ;;AAgBE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;AAbJ;;AAgBE;EACE,qBAAA;AAbJ;;AAgBE;EACE,cAAA;AAbJ;;AAgBE;EACE,mBAAA;AAbJ;;AAgBE;EACE,mBAAA;AAbJ;;AAgBE;EACE,YAAA;AAbJ;;AAgBE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AAbJ;;AAgBE;;EAEE,cAAA;AAbJ;;AAgBE;;EAEE,kBAAA;EACA,qBAAA;AAbJ;;AAgBE;EACE,qBAAA;AAbJ;;AAgBE;EACE,4BAAA;EAEA,+JAAA;EAIA,sGAAA;EACA,mHAAA;AAbJ;;AAgBE;EACE,gBAAA;AAbJ;;AAgBE;;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gDChXW;EDiXX,WChYE;EDiYF,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;EACA,YAAA;EACA,YAAA;AAbN;;AAgBE;;;;;EAKI,WAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;AAbN;;AAgBE;EACE,WAAA;AAbJ;;AAgBE;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;AAbJ;;AAgBE;EACE,YAAA;AAbJ;;AAgBE;EACE,2BAAA;AAbJ;;AAgBE;EACE,mBAAA;AAbJ;;AAgBE;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AAbJ;;AAgBE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AAbJ;;AAgBE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,iBAAA;EACA,UAAA;EAEA,6BAAA;EACA,UAAA;EACA,QAAA;AAbJ;;AAgBE;EACE,SAAA;EACA,WAAA;AAbJ;;AAgBE;;;;;;;;EAQE,UAAA;AAbJ;;AAgBE;EACE,UAAA;AAbJ;;AAgBE;EACE,sDAAA;AAbJ;;AAgBE;EACE,qDAAA;AAbJ;;AAgBE;EACE,gDAAA;AAbJ;;AAgBE;EACE,4DAAA;AAbJ;;AAgBE;EACE,kDAAA;AAbJ;;AAgBE;EACE,oDAAA;AAbJ;;AAgBE;EACE,+CAAA;AAbJ;;AAgBE;EACE,+CAAA;AAbJ;;AAgBE;EAIE;IACE,kDAAA;EAhBJ;AACF;AAmBE;EACE,gDAAA;AAjBJ;;AAoBE;EAIE;IACE,mDAAA;EApBJ;AACF;AAuBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iEAAA;AArBJ;;AAwBE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AArBJ;;AAwBE;EACE;IACE,eAAA;IACA,cAAA;EArBJ;EAuBE;IACE,YAAA;IACA,WAAA;EArBJ;AACF;AAwBE;EACE;IACE,uBAAA;EAtBJ;EAwBE;IACE,yBAAA;EAtBJ;AACF;AAyBE;EACE,mBAAA;AAvBJ;;AA0BE;;EAEE,cAAA;AAvBJ;;AA0BE;EACE;IACE,kBAAA;EAvBJ;EA0BE;IACE,UAAA;EAxBJ;EA2BE;IACE,WAAA;IACA,gBAAA;EAzBJ;EA4BE;IACE,cAAA;EA1BJ;EA4BE;IACE,yBAAA;EA1BJ;EA4BE;IACE,yBAAA;EA1BJ;EA4BE;;IAEE,sBAAA;IACA,kBAAA;IACA,wBAAA;EA1BJ;EA4BE;IACE,WAAA;EA1BJ;EA4BE;IACE,aAAA;IACA,8BAAA;EA1BJ;EA4BE;IACE,oBAAA;EA1BJ;EA4BE;IACE,gBAAA;EA1BJ;EA4BE;;;;;;;;;;;;;KAAA;EAcA;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,6BAAA;EA1BJ;EA4BE;IACE,aAAA;EA1BJ;AACF;AA6BE;EACE,cAAA;EACA,cAAA;EACA,8CAAA;EACA,eAAA;AA3BJ;;AA8BE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;AA3BJ;;AA8BE,2BAAA;AAEA;;EAEE,YAAA;AA5BJ;;AA+BE,yBAAA;AAEA;;EAEE,sBAAA;EACA,uBAAA;EACA,kCAAA;AA7BJ;;AAgCE;EACE;IACE,oBAAA;EA7BJ;AACF;AAgCE,gCAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AA/BJ;;AAkCE;EACE,iCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AA/BJ;;AAkCE;EACE,kCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AA/BJ;;AAkCE;EACE;IACE,8BAAA;IACA,UAAA;EA/BJ;AACF;AAkCE,uBAAA;AAEA;EACE,8CAAA;EACA,qBAAA;AAjCJ;;AAoCE;EACE;IAEE,kCAAA;EAlCJ;EAoCE;IAEE,iCAAA;EAnCJ;EAqCE;IAGE,kCAAA;EArCJ;EAuCE;IAEE,iCAAA;EAtCJ;AACF;AAyCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAvCJ;;AA0CE;EACE,kBAAA;EACA,mBAAA;AAvCJ;;AA0CE;EACE,gBAAA;AAvCJ;;AA0CE;EACE,gBAAA;AAvCJ;;AA0CE;EACE,yBAAA;AAvCJ;;AA0CE;EACE,aAAA;EACA,8BAAA;AAvCJ;;AA0CE;EACE,cAAA;AAvCJ;;AA0CE;EACE,8BAAA;AAvCJ;;AA0CE;EACE,2BAAA;AAvCJ;;AA0CE,eAAA;AAEA;EACE,4BAAA;EAEA,6JAAA;EAIA,oGAAA;EACA,mHAAA;AAxCJ;;AA2CE;EACE,iBAAA;AAxCJ;;AA2CE;EACE,8CAAA;EACA,eAAA;AAxCJ;;AA2CE;EACE,8CAAA;EACA,WAAA;AAxCJ;;AA2CE;EACE,8CAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,+JAAA;EAIA,uGAAA;EACA,mHAAA;EACA,YAAA;AAxCJ","sourcesContent":["@import '../../../../../sass/variables';\n\n.checkout {\n  background-color: $white;\n}\n\n.panel {\n  background-color: $white;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.form-control {\n  border: 1px solid $cinza-300;\n}\n\n#form-checkout .has-error input {\n  border-color: #F00;\n}\n\n.form-control.error {\n    border: 1px solid #e53935;\n    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;\n    transform: translate3d(0, 0, 0);\n    backface-visibility: hidden;\n    perspective: 1000px;\n  }\n\n  @keyframes shake {\n    10%,\n    90% {\n      transform: translate3d(-1px, 0, 0);\n    }\n    20%,\n    80% {\n      transform: translate3d(2px, 0, 0);\n    }\n    30%,\n    50%,\n    70% {\n      transform: translate3d(-4px, 0, 0);\n    }\n    40%,\n    60% {\n      transform: translate3d(4px, 0, 0);\n    }\n  }\n\n  /*  alterações novas  */\n\n  .panel-body-altera {\n    text-align: right;\n  }\n\n  .panel-body-altera .btn-confirmar {\n    margin-bottom: 5px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados {\n      padding-bottom: 80px;\n      padding-top: 10px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao {\n    padding: 10px;\n    border: 2px solid #00caff;\n    border-radius: 5px;\n    background-color: #fff;\n    text-align: left;\n    height: 46px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n    color: hsl(0, 0%, 30%);\n    font-size: 13px;\n    cursor: pointer;\n    user-select: none;\n    transition: all 0.5s ease-out;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.disabled {\n    background-color: #fcfcfc;\n    border: 2px solid rgba(216, 216, 216, 0.5);\n    color: #8b8b8b;\n    transition: background-color 0.5s ease, border-color 0.5s ease;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {\n    background-color: #fff;\n    border-color: rgba(216, 216, 216, 1);\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {\n    background-color: #fcfcfc;\n    border: 2px solid rgba(216, 216, 216, 0.5);\n    ;\n    color: #4379ff;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 15px;\n    font-weight: bolder;\n    padding-left: 30px;\n    transition: background-color 0.5s ease, border-color 0.5s ease;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {\n    background-color: #fff;\n    border-color: rgba(216, 216, 216, 1);\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span>span {\n    font-size: 19px;\n    line-height: 1;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {\n    margin: 0;\n    display: inline-block;\n    vertical-align: middle;\n    height: 26px;\n    width: 66px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {\n    width: 7px;\n    height: 19px;\n    display: inline-block;\n    background-image: url(/assets/icones/menu-edit.svg);\n    background-repeat: no-repeat;\n    padding: 10px;\n    background-position: center;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,\n  .cartoes-cadastrados .cartao .validade-cartao strong {\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 15px;\n  }\n\n  .remover-dom {\n    visibility: hidden;\n    opacity: 0;\n    display: none;\n  }\n\n  .flex {\n    display: flex;\n  }\n\n  .space-between {\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  h5 {\n    color: #4d4d4d;\n    font-size: 14px;\n    line-height: inherit;\n  }\n\n  .info-venda .venda:last-child {\n      margin-bottom: 20px;\n  }\n\n  .venda .valores {\n      margin-bottom: 5px;\n  }\n\n  .venda .data-entrada {\n      font-size: 12px;\n      text-align: right;\n  }\n\n  .venda .data-entrada .valor-data {\n      font-family: pague-la, \"Open Sans\", sans-serif;\n      font-weight: bolder;\n      font-size: 13px;\n  }\n\n  .venda .valor-entrada{\n    display: block;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-weight: bolder;\n    font-size: 13px;\n    text-align: right;\n  }\n\n  /* #cartoes-cadastrados, #form-checkout {\n      transition: opacity 0.5s ease;\n  } */\n\n  @media (min-width: 768px) {\n    .checkout .cls-content .cls-content-lg {\n      width: 700px;\n    }\n  }\n\n  .menu-remove {\n    background-color: #FFF;\n    width: 100px;\n    height: 35px;\n    border: 1px solid rgba(0,0,0,.15);\n    padding: 7px;\n    text-align: center;\n    border-radius: .25rem;\n    position: relative;\n    top: 12px;\n    left: -78px;\n  }\n\n  .menu-remove:hover {\n    background-color: #EFEFEF;\n  }\n\n  @media (min-width: 768px) {\n    .checkout .cls-content .cls-content-lg {\n      width: 700px;\n    }\n  }\n\n  @font-face {\n    font-family: 'pague-la';\n    src: url('/assets/fonts/pague-la.eot');\n    src: url('/assets/fonts/pague-la.eot?#iefix') format('embedded-opentype'), url('/assets/fonts/pague-la.woff2') format('woff2'), url('/assets/fonts/pague-la.woff') format('woff'), url('/assets/fonts/pague-la.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n  }\n\n  .checkout.cls-container {\n    background-color: #FFFFFF;\n  }\n\n  .checkout .cls-content {\n    padding-top: 5vh;\n  }\n\n  .checkout .rodape {\n    margin-top: 30px;\n  }\n\n  .checkout .rodape p {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .checkout .panel-content {\n    display: flex;\n  }\n\n  .checkout p,\n  .checkout h4,\n  .checkout h5 {\n    display: table;\n  }\n\n  .mb-clean {\n    margin-bottom: 0;\n  }\n\n  .checkout .panel-body1 {\n    width: 35%;\n    background-color: #fff;\n    padding: 20px 40px 25px;\n    border-bottom-left-radius: 10px;\n  }\n\n  .checkout .panel-body1 .total {\n    font-size: 18px;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n  }\n\n  .checkout .panel-body1 p {\n    color: #999999;\n    margin-bottom: 8px;\n  }\n\n  .checkout .panel-body1 h4 {\n    color: #4379ff;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 25px;\n    font-weight: 900;\n    margin-top: 0;\n  }\n\n  .checkout .texto-destaque {\n    color: #4379ff;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 18px;\n    font-weight: 900;\n    margin-top: 0;\n  }\n\n  .checkout .panel-body1 h5 {\n    margin-top: 15px;\n  }\n\n  .checkout .panel-body2 {\n    width: 65%;\n    background-color: #fcfcfc;\n    padding: 20px 40px 100px;\n  }\n\n  @media (min-width: 768px) {\n    .checkout .cartao-credito {\n      width: 100%;\n    }\n  }\n\n  .checkout .form-control {\n    font-size: 15px;\n    font-weight: bolder;\n  }\n\n  input:-moz-placeholder,\n  input::-webkit-input-placeholder,\n  input:-ms-input-placeholder {\n    color: red;\n  }\n\n  .checkout .panel {\n    border-radius: 10px;\n  }\n\n  .checkout .panel-heading {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 80px;\n    border-bottom: none;\n  }\n\n  .pagamento-seguro {\n    text-align: right;\n    position: absolute;\n    right: 40px;\n    top: 20px;\n    color: #ffffff;\n  }\n\n  .pagamento-seguro p {\n    display: inline-block;\n  }\n\n  .pagamento-seguro p strong {\n    display: block;\n  }\n\n  .checkout .panel-heading:after {\n    border-bottom: none;\n  }\n\n  .checkout .logo-paguela-cinza {\n    margin-bottom: 30px;\n  }\n\n  .checkout .logo-paguela-cinza svg {\n    height: 30px;\n  }\n\n  .checkout .panel-heading h3 {\n    color: #fff;\n    letter-spacing: 1px;\n    text-align: left;\n    font-size: 25px;\n    padding-top: 15px;\n    padding-left: 40px;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-weight: 100;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    cursor: default;\n  }\n\n  z .checkout label,\n  .registro .pad-all {\n    color: #999999;\n  }\n\n  .checkout input,\n  .registro select {\n    border-radius: 4px;\n    border-color: #d9d9d9;\n  }\n\n  .checkout input:focus {\n    border-color: #00CAFF;\n  }\n\n  .checkout .panel-heading {\n    background: rgba(0, 204, 255, 1);\n    background: -moz-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 204, 255, 1)), color-stop(70%, rgba(161, 80, 253, 1)), color-stop(100%, rgba(177, 54, 253, 1)));\n    background: -webkit-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -o-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -ms-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ccff', endColorstr='#b136fd', GradientType=1);\n  }\n\n  .mt-20 {\n    margin-top: 20px;\n  }\n\n  .btn-registrar,\n  .btn-primary {\n      position: absolute;\n      bottom: 40px;\n      right: 40px;\n      font-family: $fonte-pague-la;\n      color: $white;\n      font-size: 1.8rem;\n      padding: 7.5px 27px;\n      border-radius: 5px;\n      letter-spacing: 0.8px;\n      background: #22b5ff;\n      background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n      background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n      border: none;\n      float: right;\n  }\n\n  .btn-registrar:active,\n  .btn-primary:active,\n  .btn-registrar:hover,\n  .btn-primary:hover,\n  .btn-registrar:focus .btn-primary:focus {\n      color: #fff;\n      background: #22b5ff;\n      background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n      background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n  }\n\n  #reinicia-venda {\n    float: none;\n  }\n\n  .cadeado {\n    max-width: 35px;\n    display: inline-block;\n    position: relative;\n    top: 2px;\n  }\n\n  .cadeado svg {\n    height: 30px;\n  }\n\n  #cartao-error {\n    margin-bottom: 0 !important;\n  }\n\n  .checkout .form-group {\n    margin-bottom: 15px;\n  }\n\n  .checkout .form-group .control-label {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n  }\n\n  img.logo-cliente {\n    max-width: 165px;\n    max-height: 117px;\n    margin: 10px auto;\n  }\n\n  .bandeira-cartao {\n    width: 50px;\n    height: 27px;\n    background-size: 100% auto;\n    background-repeat: no-repeat;\n    margin: 7px 0 0 0;\n    opacity: 0;\n    -webkit-transition: opacity .5s ease;\n    transition: opacity .5s ease;\n    right: 8px;\n    top: 3px;\n  }\n\n  .checkout .has-feedback label~.form-control-feedback {\n    top: 27px;\n    right: 10px;\n  }\n\n  .master,\n  .visa,\n  .elo,\n  .diners,\n  .aura,\n  .jcb,\n  .hipercard,\n  .american-express {\n    opacity: 1;\n  }\n\n  .default {\n    opacity: 0;\n  }\n\n  .master {\n    background-image: url('/assets/icones/mastercard.svg');\n  }\n\n  .hipercard {\n    background-image: url('/assets/icones/hipercard.svg');\n  }\n\n  .visa {\n    background-image: url('/assets/icones/visa.svg');\n  }\n\n  .american-express {\n    background-image: url('/assets/icones/american-express.svg');\n  }\n\n  .diners {\n    background-image: url('/assets/icones/diners.svg');\n  }\n\n  .discover {\n    background-image: url('/assets/icones/discover.svg');\n  }\n\n  .elo {\n    background-image: url('/assets/icones/elo.svg');\n  }\n\n  .jcb {\n    background-image: url('/assets/icones/jbc.png');\n  }\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n  only screen and (min-resolution: 1.5dppx),\n  (-webkit-min-device-pixel-ratio: 1.5),\n  (min-resolution: 144dpi) {\n    .jcb {\n      background-image: url('/assets/icones/jbc@2x.png');\n    }\n  }\n\n  .aura {\n    background-image: url('/assets/icones/aura.png');\n  }\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n  only screen and (min-resolution: 1.5dppx),\n  (-webkit-min-device-pixel-ratio: 1.5),\n  (min-resolution: 144dpi) {\n    .aura {\n      background-image: url('/assets/icones/aura@2x.png');\n    }\n  }\n\n  .btn.loading {\n    color: transparent;\n    height: 35px;\n    width: 35px;\n    padding: 0;\n    border-radius: 50%;\n    animation: loadBotao .25s ease, spin .75s linear infinite .25s;\n  }\n\n  .btn.loading:before {\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    border-radius: 50%;\n    background-color: #fcfcfc;\n    position: relative;\n    display: block;\n    margin: 1px;\n  }\n\n  @keyframes loadBotao {\n    from {\n      height: initial;\n      width: initial;\n    }\n    to {\n      height: 35px;\n      width: 35px;\n    }\n  }\n\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  #nometitular-error {\n    margin-bottom: 40px;\n  }\n\n  #nometitular-error,\n  #cartao-error {\n    color: #eb2521;\n  }\n\n  @media (max-width: 767px) {\n    .checkout .panel-heading h3 {\n      padding-left: 20px;\n    }\n\n    .checkout .cls-content {\n      padding: 0;\n    }\n\n    .checkout .cls-content .cls-content-lg{\n      width: 100%;\n      box-shadow: none;\n    }\n\n    .checkout .panel-content {\n      display: block;\n    }\n    .logo-cliente {\n      display: block !important;\n    }\n    .info-loja * {\n      display: block !important;\n    }\n    .panel-body2,\n    .panel-body1 {\n      width: 100% !important;\n      text-align: center;\n      padding: 20px !important;\n    }\n    .pagamento-seguro {\n      right: 20px;\n    }\n    .info-pagamento {\n      display: flex;\n      justify-content: space-between;\n    }\n    #nometitular {\n      margin-bottom: 100px;\n    }\n    .checkout .panel-heading {\n      border-radius: 0;\n    }\n    /* .checkout .panel-heading h3 {\n      position: relative;\n      text-align: center;\n      padding: 15px 0 0;\n    }\n    .pagamento-seguro {\n      position: relative;\n      text-align: center;\n      top: 0;\n      right: 0;\n    }\n    .pagamento-seguro p {\n      text-align: right;\n    } */\n    .checkout .panel-body1 p.totais {\n      position: absolute;\n      float: left;\n      left: 50%;\n      transform: translate(-50%, 0);\n    }\n    .checkout .form-group [for=validadeano].control-label {\n      display: none;\n    }\n  }\n\n  #resultado-sucesso h3 {\n    display: block;\n    color: #00caff;\n    font-family: pague-la, \"open sans\", sans-serif;\n    margin-top: 8px;\n  }\n\n  #resultado-reprovado h3 {\n    display: block;\n    color: #e95753;\n    margin-top: 8px;\n    font-family: pague-la, \"open sans\", sans-serif;\n  }\n\n  /*altura SVGS de validação*/\n\n  #resultado-sucesso svg,\n  #resultado-reprovado svg {\n    height: 75px;\n  }\n\n  /*animação círculos svgs*/\n\n  #resultado-sucesso svg circle,\n  #resultado-reprovado svg circle {\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 1000;\n    animation: dash 2.5s ease forwards;\n  }\n\n  @keyframes dash {\n    to {\n      stroke-dashoffset: 0;\n    }\n  }\n\n  /* animação somente de sucesso */\n\n  #resultado-sucesso svg polyline {\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 1000;\n    animation: dash 3.5s ease forwards;\n    animation-delay: 0.25s;\n  }\n\n  #resultado-reprovado svg .linha-1 {\n    transform: translate(20px, -20px);\n    opacity: 0;\n    animation: entrando 0.25s ease-in forwards;\n    animation-delay: 0.3s;\n  }\n\n  #resultado-reprovado svg .linha-2 {\n    transform: translate(-20px, -20px);\n    opacity: 0;\n    animation: entrando 0.25s ease-in forwards;\n    animation-delay: 0.4s;\n  }\n\n  @keyframes entrando {\n    to {\n      transform: translate(0px, 0px);\n      opacity: 1;\n    }\n  }\n\n  /* animação reprovado */\n\n  #resultado-reprovado svg {\n    animation: shake-reprovado 0.35s ease forwards;\n    animation-delay: 0.6s;\n  }\n\n  @keyframes shake-reprovado {\n    10%,\n    90% {\n      transform: translate3d( 0, -1px, 0);\n    }\n    20%,\n    80% {\n      transform: translate3d( 0, 2px, 0);\n    }\n    30%,\n    50%,\n    70% {\n      transform: translate3d( 0, -4px, 0);\n    }\n    40%,\n    60% {\n      transform: translate3d(0, 4px, 0);\n    }\n  }\n\n  #resultado-sucesso .bandeira-cartao {\n    position: absolute;\n    top: -5px;\n    right: 0px;\n  }\n\n  #resultado-sucesso .info-cartao {\n    position: relative;\n    padding-right: 75px;\n  }\n\n  #resultado-sucesso .fechar {\n    margin-top: 40px;\n  }\n\n  #resultado-sucesso .info-transacao-aprovada {\n    margin-top: 20px;\n  }\n\n  #resultado-sucesso .info-transacao-aprovada hr {\n    margin: 10px 0 !important;\n  }\n\n  #resultado-sucesso .dados-aprovados {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .margin-auto {\n    margin: 0 auto;\n  }\n\n  .mb-30 {\n    margin-bottom: 30px !important;\n  }\n\n  .mt-30 {\n    margin-top: 30px !important;\n  }\n\n  /* página 404 */\n\n  .pagina-404 #container {\n    background: rgba(0, 247, 255, 1);\n    background: -moz-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 247, 255, 1)), color-stop(75%, rgba(170, 0, 255, 1)), color-stop(100%, rgba(170, 0, 255, 1)));\n    background: -webkit-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -o-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -ms-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00f7ff', endColorstr='#aa00ff', GradientType=1);\n  }\n\n  .pagina-404 .btn-confirmar {\n    position: initial;\n  }\n\n  .pagina-404 .text-main {\n    font-family: pague-la, 'open sans', sans-serif;\n    font-size: 2rem;\n  }\n\n  h1.error-code {\n    font-family: pague-la, 'open sans', sans-serif;\n    color: #fff;\n  }\n\n  .checkout .btn-confirmar {\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 1.7rem;\n    padding: 10px 25px;\n    border-radius: 5px;\n    letter-spacing: 0.6px;\n    background: rgba(0, 204, 255, 1);\n    background: -moz-linear-gradient(115deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(0, 204, 255, 1)), color-stop(70%, rgba(161, 80, 253, 1)), color-stop(100%, rgba(177, 54, 253, 1)));\n    background: -webkit-linear-gradient(115deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -o-linear-gradient(115deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -ms-linear-gradient(115deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: linear-gradient(115deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ccff', endColorstr='#b136fd', GradientType=1);\n    border: none;\n  }\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
